<template>
  <el-dialog :title="opts.title" :visible.sync="dialogVisible" :append-to-body="appendToBody" width="1200px" @close="handleClose">
    <div v-if="pictureZoneUrl">
      <iframe name="newPictureZone" title="新素材空间" :src="pictureZoneUrl" ref="iframeRef" width="100%" height="500px" frameborder="0" allow="clipboard-read; clipboard-write"></iframe>
    </div>
    <div slot="footer" style="text-align: right">
      <el-button @click="handleClose">取消</el-button>
      <el-button style="margin-right: 10px" type="primary" @click.native="handleOk">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { getImgEditorOrigin } from '@/utils/domainHelper';
export default {
  components: {},
  props: {
    appendToBody: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogVisible: false,
      pictureZoneUrl: '',
      selectedList: [],
      opts: {},
      targetOrigin: getImgEditorOrigin(),
      // 点击确定后等待子页面回传 FILES_SELECTED 的标记
      waitingOk: false,
      // SELECT_IMAGES 重试定时器
      selectRetryTimer: null,
      // SELECT_IMAGES 重试次数
      selectRetryCount: 0,
      // 记住用户选择的文件夹 ID
      folderId: '',
    };
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        window.addEventListener('message', this.messageHandler, false);
      }
    },
  },

  methods: {
    method_open(opts) {
      const defaultOpts = {
        title: '选择图片',
        canCheckDataType: 'file',
        isSingle: true,
        limitSuffix: '.jpg,.jpeg,.png,.gif',
        id: '',
        productCode: ''
      }
      this.opts = { ...defaultOpts, ...opts }
      // 兼容：若未显式传入 id，则使用 productCode 作为 id 传给子页面
      if (this.opts.productCode && !this.opts.id) {
        this.opts.id = this.opts.productCode
      }
      // 接收 folderId 参数并暂存；兼容传入的是函数的情况（inject 函数式 provide）
      let folderId = opts.folderId;
      if (typeof folderId === 'function') {
        folderId = folderId();
      }
      if (folderId) {
        this.folderId = folderId;
      }
      this.dialogVisible = true;
      this.buildUrl();
    },
    messageHandler(event) {
      // 简单的域校验：仅允许当前 targetOrigin 的域
      const eventHost = (new URL(event.origin)).hostname;
      const allowedHost = (new URL(this.targetOrigin)).hostname;
      if (eventHost !== allowedHost || !event.data) return;

      const data = event.data || {};
      if (data.type === 'FILES_LOADED') {
        this.sendCookieToIframe();
        this.sendProductCodeToIframe();
        return;
      }
      // 子页面就绪后，根据类型切换到选择模式（图片/文件夹）
      if (data.type === 'FILES_READY') {
        this.selectRetryCount = 0;
        this.sendSelectByType();
        this.startSelectModeRetry();
        return;
      }
      // 子页面模式切换确认
      if (data.type === 'SELECT_MODE_READY') {
        this.selectRetryCount = 999; // 标记已确认，停止重试
        if (this.selectRetryTimer) {
          clearTimeout(this.selectRetryTimer);
          this.selectRetryTimer = null;
        }
        return;
      }
      // 监听复制文本事件
      if (data.type === 'COPY_TEXT') {
        const text = typeof data.data === 'string' ? data.data : (data.text || '');
        if (!text) {
          return this.$message.warning('未获取到可复制的文本');
        }
        this.copyText(text);
        return;
      }
      // 监听文件夹切换事件，记住用户选择的文件夹
      if (data.type === 'FOLDER_CHANGED') {
        const newFolderId = data.folderId || data.data?.folderId || '';
        this.folderId = newFolderId;
        localStorage.setItem('km_picture_folder_id', newFolderId);
        return;
      }
      // 约定动作：FILES_SELECTED
      if (data.type === 'FILES_SELECTED') {
        const resources = Array.isArray(data.data) ? data.data : [];
        // 只有图片才进行梳理映射；文件夹或其他类型直接透传
        if (this.opts && this.opts.canCheckDataType === 'folder') {
          this.selectedList = resources;
        } else {
          const allowed = (this.opts && this.opts.limitSuffix || '')
            .split(',')
            .map(s => s.trim().replace('.', ''))
            .filter(Boolean);
          const list = resources
            .filter(item => {
              const ext = ((item.url || item.name || '').split('.').pop() || '').toLowerCase();
              return allowed.length ? allowed.includes(ext) : true;
            })
            .map(item => {
              const name = (item.name) || (item.url?.split('/').pop() || '未命名');
              return {
                id: item.id,
                name,
                url: item.url,
                fileInfo: item,
              };
            });
          this.selectedList = list;
        }

        // 若是点击了确定后请求的数据，则在这里继续后续操作
        if (this.waitingOk) {
          this.waitingOk = false;
          if (!this.selectedList.length) {
            const label = this.opts.canCheckDataType === 'folder' ? '文件夹' : '图片';
            return this.$message.warning(`请选择${label}！`);
          }
          const list = JSON.parse(JSON.stringify(this.selectedList));
          this.handleClose();
          this.$nextTick(() => {
            this.opts.okFn && this.opts.okFn(list)
          });
        }
      }
    },
    buildUrl() {
      const fileTypes = (this.opts.limitSuffix || '').replace(/\./g, '');
      const folderIdParam = this.folderId ? `&folderId=${this.folderId}` : '';
      const params = encodeURIComponent(
        `showSideMenu=false&mode=pick${this.opts.id ? `&id=${this.opts.id}` : ''}&canCheckDataType=${this.opts.canCheckDataType}&selectType=${this.opts.canCheckDataType || 'file'}&fileTypeList=${fileTypes}&isMultiChoice=${!this.opts.isSingle}${this.opts.outerId ? `&outerId=${this.opts.outerId}` : ''}${folderIdParam}`
      );
      const origin = this.targetOrigin || getImgEditorOrigin();
      this.pictureZoneUrl = `${origin}/#/files?${params}`;
    },
    sendCookieToIframe() {
      const cookie = document.cookie;
      if (!cookie) return;
      const iframe = this.$refs.iframeRef;
      const win = iframe && iframe.contentWindow;
      if (!win) return;
      try {
        win.postMessage({ type: 'SET_COOKIE', cookie }, this.targetOrigin);
      } catch (e) {
        // ignore
      }
    },
    // 发送商品ID（productCode）给子页面
    sendProductCodeToIframe() {
      const code = (this.opts && (this.opts.productCode || this.opts.id)) || '';
      if (!code) return;
      const iframe = this.$refs.iframeRef;
      const win = iframe && iframe.contentWindow;
      if (!win) return;
      try {
        win.postMessage({ type: 'SET_PRODUCT_CODE', productCode: code }, this.targetOrigin);
      } catch (e) {
        // ignore
      }
    },
    // 根据 canCheckDataType 发送选择模式控制
    sendSelectByType() {
      const iframe = this.$refs.iframeRef;
      const win = iframe && iframe.contentWindow;
      if (!win) return;
      const msgType = this.opts && this.opts.canCheckDataType === 'folder' ? 'SELECT_FOLDERS' : 'SELECT_IMAGES';
      try {
        win.postMessage({ type: msgType }, this.targetOrigin);
      } catch (e) {
        // ignore
      }
    },
    // 等待 SELECT_MODE_READY 确认，超时未收到则重试
    startSelectModeRetry() {
      this.selectRetryTimer = setTimeout(() => {
        if (this.selectRetryCount < 2) {
          this.selectRetryCount++;
          this.sendSelectByType();
          this.startSelectModeRetry();
        }
      }, 1000);
    },
    // 主动向子页面请求当前已选择的文件（或文件夹）
    requestFilesSelected() {
      const iframe = this.$refs.iframeRef;
      const win = iframe && iframe.contentWindow;
      if (!win) return;
      try {
        win.postMessage({ type: 'REQUEST_FILES_SELECTED' }, this.targetOrigin);
      } catch (e) {
        // ignore
      }
    },
    handleOk() {
      // 旧逻辑（注释保留）：直接使用本地 selectedList
      /*
      if (!this.selectedList.length) {
        const label = this.opts.canCheckDataType === 'folder' ? '文件夹' : '图片';
        return this.$message.warning(`请选择${label}！`);
      }
      const list = JSON.parse(JSON.stringify(this.selectedList));
      this.handleClose();
      this.$nextTick(() => {
        this.opts.okFn && this.opts.okFn(list)
      });
      */

      // 新逻辑：先向子页面发起 REQUEST_FILES_SELECTED，再在 FILES_SELECTED 回调里继续
      this.waitingOk = true;
      this.requestFilesSelected();
    },

    handleClose() {
      if (this.selectRetryTimer) {
        clearTimeout(this.selectRetryTimer);
        this.selectRetryTimer = null;
      }
      this.selectRetryCount = 0;
      this.folderId = '';
      this.dialogVisible = false;
    },
    // 通用复制到剪贴板方法（支持 Clipboard API 与回退方案）
    async copyText(text) {
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(text);
        } else {
          const textarea = document.createElement('textarea');
          textarea.value = text;
          textarea.setAttribute('readonly', '');
          textarea.style.position = 'absolute';
          textarea.style.left = '-9999px';
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand('copy');
          document.body.removeChild(textarea);
        }
        this.$message.success('文本已复制到剪贴板');
      } catch (e) {
        this.$message.error('复制失败，请手动复制');
      }
    }
  },
  mounted() {},
  beforeDestroy() {
    if (this.selectRetryTimer) {
      clearTimeout(this.selectRetryTimer);
      this.selectRetryTimer = null;
    }
    window.removeEventListener('message', this.messageHandler, false);
    // 清理 URL，确保下次打开时重新加载
    this.pictureZoneUrl = '';
  },
};
</script>
  
<style lang="scss" scoped>
::v-deep .el-dialog__body {
  height: auto;
  padding-bottom: 0;
  min-height: 100px;
}
::v-deep .el-dialog__footer {
  .el-button {
    position: relative;
    z-index: 10;
  }
}
</style>